import { createReducer, on } from '@ngrx/store';
import * as fromSharedActions from '../actions/shared.action';

export const featureKey = 'shared';

export interface State {
  showLoading: boolean;
}

export const initialState: State = {
  showLoading: false,
};

export const reducer = createReducer(
  initialState,
  on(fromSharedActions.setLoadingSpinner, (state: State, props: any) => ({
    ...state,
    showLoading: props.status,
  })),
);
